@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */
:host {
  display: block;
}

a , a:visited {
  color: black;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: black;
  font-size: 16px;
 
}

#raw-html-style {
  padding:10px;
}
.slide-title {
  font-weight: bold;
}
.carousel-indicators  {
  position: static;
  margin-top:20px;
 }
.carousel-indicators button {
  border-bottom: none;
  width: 70px;
  height: 100%;
  border-top:3px solid white
 
}
.carousel-indicators button.active {
  /* border-bottom: 2px  solid red; */
  width: 70px;
  height: 100%;
  border-top:3px solid #ce2127
  
}

/* .carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #fff;
} */
/* 
.carousel-item {
  transition: transform 2s ease, opacity .5s ease-out;
 } */




  .card {
    border: none;
  }
